export default __webpack_public_path__ + "static/media/step3.19419f98.webp";